var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHawaii(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    enableBackground: "new 0 0 288 288",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "56.912,79.965 68.175,83.988 73.269,83.988 77.294,74.868 76.22,68.252 67.102,68.252 58.518,70.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.318,109.736 151.318,113.221 140.86,113.221 138.448,109.736 131.473,113.221 123.158,101.151 123.158,96.593  137.24,89.35 146.494,105.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.414,129.316 178.414,132.802 182.969,138.971 189.141,137.363 189.141,133.07 186.727,129.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.878,119.93 178.414,123.683 189.141,123.683 195.307,117.514 181.093,117.514 178.414,117.514  169.561,115.639  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.316,161.871c5.254,1.074,30.084,14.021,30.442,15.096c0.357,1.074,4.646,12.874,4.646,12.874s9.66,5.724,9.304,6.798 c-0.358,1.073-6.08,8.582-7.867,9.297c-1.79,0.719-8.228,3.221-9.657,3.221c-1.432,0-3.229-0.155-4.291,0 c-1.566,0.222-6.074,1.785-6.074,1.785s-8.59,13.949-9.66,13.949c-1.073,0-10.42-5.008-11.11-6.082 c-0.519-0.805,1.045-15.769-0.528-23.272c-0.689-3.275-3.293-5.804-6.601-7.479v-6.797l4.649-2.146 c2.144-2.861,5.722-7.866,5.722-7.866l-3.935-2.863l0.119-5.765C231.254,161.77,232.714,161.339,235.316,161.871z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.039,86.669 39.746,86.669 44.303,79.697 42.962,77.817 38.671,77.817  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.697,129.316l4.828-5.633l12.07,5.633h5.631l11.535,7.777v3.487l-12.337,4.829c0,0-6.706,2.411-8.583,0 C204.964,142.995,193.697,129.316,193.697,129.316z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHawaii);
export default __webpack_public_path__ + "static/media/hawaii.d57b85aeb0e91c7653b89918e63c7f30.svg";
export { ForwardRef as ReactComponent };